import dotenv from "dotenv"
import type { Geotag } from "./cms-schema/geotagTypes"

if (typeof process !== "undefined") {
  dotenv.config()
}

export enum PHC_ENV {
  LOCAL = "local",
  DEV = "dev",
  PRD = "prd",
  PROD = "prod",
}

// Cross-runtime (Vite vs Node) compatibility
// eslint-disable-next-line @typescript-eslint/prefer-optional-chain, @typescript-eslint/no-unnecessary-condition
export const ENV: PHC_ENV = ((import.meta.env && import.meta.env.ENV) ||
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  (typeof process !== "undefined" && process?.env?.ENV)) as PHC_ENV
console.log("ENV", ENV)

/** @deprecated */
export const IS_PRD = ENV === PHC_ENV.PRD
export const IS_PROD = ENV === PHC_ENV.PROD
export const IS_DEV = ENV === PHC_ENV.DEV
export const IS_LOCAL = ENV === PHC_ENV.LOCAL

export const SANITY_PROJECT_ID = "i46wuz36"

const SERVICE_MAP = {
  [PHC_ENV.PROD]: {
    assetService: "https://preferences.phcglobal-apps.com",
    cap: "https://cap.phcglobal-apps.com",
    cms: "https://cms.phcglobal-apps.com",
    aiService: "https://navigator.phcglobal-apps.com",
    threatAnalytics: "https://threat-analytics.phcglobal-apps.com/",
  },
  [PHC_ENV.DEV]: {
    assetService: "https://preferences.dev.phcglobal-apps.com",
    cap: "https://cap.dev.phcglobal-apps.com",
    cms: "https://cms.dev.phcglobal-apps.com",
    aiService: "https://navigator.dev.phcglobal-apps.com",
    threatAnalytics: "https://threat-analytics.dev.phcglobal-apps.com/",
  },
  [PHC_ENV.PRD]: {
    assetService: "https://preferences.phcglobal-apps.com",
    cap: "https://cap.phcglobal-apps.com",
    cms: "https://cms.phcglobal-apps.com",
    aiService: "https://navigator.phcglobal-apps.com",
    threatAnalytics: "https://threat-analytics.phcglobal-apps.com/",
  },
  [PHC_ENV.LOCAL]: {
    assetService: "https://preferences.dev.phcglobal-apps.com",
    cap: "https://cap.dev.phcglobal-apps.com",
    cms: "https://cms.dev.phcglobal-apps.com",
    aiService: "https://navigator.dev.phcglobal-apps.com",
    threatAnalytics: "https://threat-analytics.dev.phcglobal-apps.com/",
  },
}

export const getAssetServiceDomain = (env?: PHC_ENV) =>
  SERVICE_MAP[env || ENV].assetService
export const getCapDomain = (env?: PHC_ENV) => SERVICE_MAP[env || ENV].cap
export const getAiServiceDomain = (env?: PHC_ENV) =>
  SERVICE_MAP[env || ENV].aiService
export const getThreatAnalyticsDomain = (env?: PHC_ENV) =>
  // Guard `import.meta.env` like ENV above: it is undefined in the server's CJS
  // bundle (tsdown rewrites `import.meta` to `{}`), so an unguarded
  // `import.meta.env.VITE_...` throws "Cannot read properties of undefined" and
  // breaks every TA call (webhook upsert + reindexer). Fall back to SERVICE_MAP.
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain, @typescript-eslint/no-unnecessary-condition
  (import.meta.env && import.meta.env.VITE_THREAT_ANALYTICS_URL) ||
  SERVICE_MAP[env || ENV].threatAnalytics
export const getCMSDomain = (env?: PHC_ENV) => SERVICE_MAP[env || ENV].cms

export const GLOBAL_GEOTAG = {
  _key: "000",
  _type: "geotag",
  locationId: "000",
  id: "000",
  name: "Global",
  geotagType: "adminBoundary",
} satisfies Geotag
